import * as rq from '@tanstack/react-query';

import type { IAlertsRepository } from '@/alerts/domain/repositories/alerts.repository';
import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';

export namespace ListFindingsThroughputPerDay {
  export const key = (input: Input) => [
    'alerts',
    'findings-throughput-per-day',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Input = IAlertsRepository.GetFindingsThroughputInput;
  export type Output = IAlertsRepository.GetFindingsThroughputOutput;

  export function useQuery(input: Input) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      queryKey: key(input),
      queryFn: () => repositories.alerts.getFindingsThroughput(input),
    });
  }
}
